import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import CategorySection from "./components/CategorySection";
import LatestSection from "./components/LatestSection";
import PopularSection from "./components/PopularSection";
import FeaturesSection from "./components/FeaturesSection";
import FAQSection from "./components/FAQSection";
import CTASection from "./components/CTASection";

const homeSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: "红桃影视",
  url: "https://hongtaomovies.com/",
  description: "红桃影视在线观看 - 免费高清影视资源一站畅享",
  potentialAction: {
    "@type": "SearchAction",
    target: "https://hongtaomovies.com/search?q={search_term_string}",
    "query-input": "required name=search_term_string",
  },
};

const orgSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "红桃影视",
  url: "https://hongtaomovies.com/",
  description: "免费高清影视资源平台",
  contactPoint: {
    "@type": "ContactPoint",
    email: "contact@hongtaomovies.com",
    contactType: "customer service",
    availableLanguage: "Chinese",
  },
};

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(homeSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(orgSchema) }}
      />
      <Navbar />
      <main>
        <HeroSection />
        <CategorySection />
        <LatestSection />
        <PopularSection />
        <FeaturesSection />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}